import { render, staticRenderFns } from "./articleSort.vue?vue&type=template&id=6204becc&scoped=true&"
import script from "./articleSort.vue?vue&type=script&lang=js&"
export * from "./articleSort.vue?vue&type=script&lang=js&"
import style0 from "./articleSort.vue?vue&type=style&index=0&id=6204becc&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6204becc",
  null
  
)

export default component.exports